module.exports = __webpack_public_path__ + "66e07d0e8ca5f02edf0c0328b58115a8.svg";